/**
 * Initialize Equation fields.
 * @param {object} form - the form item.
 */
const initEquation = function(form) {
	const equations = form.element.querySelectorAll('[data-fieldset-type="equation"]');
	if (!equations || equations.length < 1) return;

	const operators = {
		'+': function(a, b) {
			return a + b;
		},
		'-': function(a, b) {
			return a - b;
		},
		'*': function(a, b) {
			return a * b;
		},
		'/': function(a, b) {
			return a / b;
		}
	};

	/**
	 * Evaluate using the value fields given.
	 * @param {HTMLElement} operations - the operations (left side) of equation
	 * @param {HTMLElement} evaluation - the equation value
	 */
	function evaluate(operations, evaluation) {
		let total = parseFloat(operations[0].value || 0);
		for (let i = 1; i < operations.length; i++) {
			const operation = operations[i];
			total = operators[operation.dataset.operator](total, parseFloat(operation.value || 0));
		}
		evaluation.value = total;
	}

	/**
	 * Initialize the equation.
	 * @param {HTMLElement} equation - the equation fieldset
	 */
	function init(equation) {
		const operations = equation.querySelectorAll('[data-equation="operation"]');
		const evaluation = equation.querySelector('[data-equation="evaluation"]');
		if (!operations) return;

		evaluate(operations, evaluation);
		operations.forEach(function(operation) {
			operation.addEventListener('input', function() {
				evaluate(operations, evaluation);
			});
		});
	}

	equations.forEach(function(item) {
		init(item);
	});
};

export default initEquation;